import { Component, OnInit, Inject, ViewChild, Input } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../../system/auth.service';
import { CourseService } from '../../../api/Services/maintenance/course.service';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from '../../../common/dialog.service';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { AssignStudentCoursesService } from '../../../api/Services/maintenance/assign-student-courses.service';
@Component({
  selector: 'app-assign-student-course',
  templateUrl: './assign-student-course.component.html',
  styleUrls: ['./assign-student-course.component.css']
})
export class AssignStudentCourseComponent implements OnInit {
  

 
  @Input() data;
  public displayedColumns: string[] = ['cou_vc_name', 'mod_vc_name', 'opcion'];
  public dataSource = new MatTableDataSource<any[]>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('paginatorDatasource', { read: MatPaginator, static: true }) paginator: MatPaginator;

  assign_student_course: FormGroup;
  public parameters: any[];
  public courses: any[];
  public default_select_category: string;
  public default_select_course: string;

  constructor(
 
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private courseServices: CourseService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    private assignServices: AssignStudentCoursesService
  ) {
 
    this.default_select_category = '0';
    this.default_select_course = '';
  }

   
  ngOnInit(): void {
    this.initForm();
    this.LoadInitial();

    if (this.data.tabData.element) {

      this.LoadAssignCourseStudent(this.data.tabData.element.stu_bi_id);

      this.change_category(0);
    }

    
  }


  public initForm() {

    this.assign_student_course = this.formBuilder.group({
      cost_bi_id: [null],
      cou_in_category: [null],
      cou_in_id: [null, Validators.required],
      stu_bi_id: [null, Validators.required] 

    });

    this.assign_student_course.controls['stu_bi_id'].setValue(this.data.tabData.element.stu_bi_id);
  }

  public LoadInitial() {
    this.parameters = this.authService.getParameters();
  }

  public LoadAssignCourseStudent(stu_bi_id:number)
  {

    this.assignServices.GetAll(stu_bi_id).subscribe(
      data => {
        if (data['sucess']) {
          let result = data['data'];
          this.dataSource = new MatTableDataSource<any[]>(result);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;

        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }
      }
    );

  }

  public change_category(value) {
    console.log(value);
    this.courseServices.GetAll(value,0,2).subscribe(
      data => {
        console.log(data);

        if (data['sucess']) {
          let result = data['data'];
          console.log(result);
          this.courses = result;
        }
        else {
          this.courses = null;
          this.toastr.warning('hubo un problema al tratar de obtener los datos', 'Advertencia');
        }

      }
    );

  }

  public save() {

    if (this.assign_student_course.valid) {
      this.dialogService.openConfirmDialog('¿Seguro de guardar este registro?')
        .afterClosed().subscribe(res => {
          if (res) {
           
            this.assign_student_course.controls['stu_bi_id'].setValue(this.data.tabData.element.stu_bi_id);
            this.assignServices.Insert(this.assign_student_course.getRawValue()).subscribe(
              data => {
                console.log(data);
                
                if (data['sucess']) {
                  
                  this.default_select_category = '0';
                  this.default_select_course = '';
                  this.change_category(0);
                  this.LoadAssignCourseStudent(this.data.tabData.element.stu_bi_id);
                  this.toastr.success(data['msg'], 'Correcto');
                }
                else {
                  this.toastr.warning(data['msg'], 'Advertencia');
                }
              }
            );
          }
        });

    }


    else {
      this.toastr.warning('Por favor complete los datos del formulario.', 'Advertencia');
    }

  }
  public cancel() { 

  }

  public delete(element){

    this.dialogService.openConfirmDialog('¿Seguro de eliminar este registro?')
    .afterClosed().subscribe(res => {
      if (res) {
        this.assignServices.Delete(element.cost_bi_id).subscribe(
          data => {
            if (data['sucess']) {
              this.LoadAssignCourseStudent(this.data.tabData.element.stu_bi_id);
              this.toastr.success(data['msg'], 'Correcto');

            }
            else {
              this.toastr.warning(data['msg'], 'Advertencia');
            }


          }
        );
      }
    });

  }

 
}
